<template>
  <div>
    <el-upload
      :action="this.$store.getters.imgUrl"
      list-type="picture-card"
      :headers="header"
      :file-list="list"
      :on-preview="handlePictureCardPreview"
      :on-remove="handleRemove"
      :data="action"
      :on-success="handleAvatarSuccess"
      :limit="limit"
      :on-exceed="exceed"
    >
      <i class="el-icon-plus" />
    </el-upload><div v-if="delImg" slot="tip">
    <div v-show="theText" style="display:flex; align-items: center;">
<!--      <el-button size="small" type="danger" icon="el-icon-delete" circle @click="clears" />-->
      <span  class="specificationPrompt">
                        <span>查看UI图设计规范</span>
                        <el-image
                            style="width: 32px; height: 32px;margin-left: 5px;"
                            src="https://admin-1305822803.cos.ap-beijing.myqcloud.com/img/designSpecification.jpeg"
                            :preview-src-list="[
                                'https://admin-1305822803.cos.ap-beijing.myqcloud.com/img/designSpecification.jpeg',
                            ]"
                        >
                        </el-image>
                    </span>
    </div>
    <div v-show="theText" slot="tip" class="el-upload__tip waring">

      {{ theText }}
    </div>
  </div>

    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    },
    limit:{
        type:[String,Number],
        default:3
    },
    action: {
      type: Object
    },
    theText: {
      type: String,
      default: "",
    },
    delImg: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogVisible: false,
      dialogImageUrl: '',
      header: {
        Token: sessionStorage.getItem('token')
      },
      baseurl: this.$store.state.env.cdnImg,
      yu: '/' + this.$store.state.env.domain,
      imgBase:process.env.VUE_APP_STATIC_DIR
    }
  },
  methods: {
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },

    handleRemove(file, fileList) {
      // var arr = this.form.productImages.filter(item => item.url != file.url)
      // this.form.productImages = fileList
      this.$emit('update:list', fileList)
      this.$emit('changes', fileList)
    },
    handleAvatarSuccess(res, file) {
      if (res.errorCode == 200) {
        // console.log(res)
        var arr = this.list
        arr.push({
          name: file.name,
          url: this.baseurl + this.imgBase + res.data.url
        })
        this.$emit('update:list', arr)
        this.$emit('changes', arr)
      } else {
        this.$emit('update:list', [...this.list])
        this.$emit('changes', [...this.list])
        this.$message.error(res.message)
      }
      // this.form.banner = URL.createObjectURL(file.raw)
    },
    exceed() {
      this.$message.warning('最多传三张图片')
    }
  }
}
</script>

<style lang="less" scoped>
.waring {
  color: #fda400;
  line-height: 24px;
}
.specificationPrompt {
  display: flex;
  align-items: center;
  margin-left: 10px;
  // font-weight: bold;
  color: #f56c6c;
  font-size: 16px;
}
</style>
